import { render, staticRenderFns } from "./ReportCallLogs.vue?vue&type=template&id=9738255e&"
import script from "./ReportCallLogs.vue?vue&type=script&lang=js&"
export * from "./ReportCallLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports